import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { selectLeaseIds } from './userSelectors';

// Base selectors
export const selectLinkedAccounts = (state: RootState) => state.home.linkedAccounts;

export const linkedAcctsConnectionsLoading = (state: RootState) => {
  return state.home.isLoading || false;
};

// Simple alias for consistency with web app naming
export const linkedAcctsConnections = selectLinkedAccounts;

export const selectConnectionLeaseIds = createSelector(
  [selectLinkedAccounts],
  (linkedAccounts) => {
    return (linkedAccounts || []).reduce<number[]>((acc, conn: any) => {
      if (Array.isArray(conn.leaseIds)) {
        return acc.concat(conn.leaseIds.filter((id: any) => Number.isFinite(id)) as number[]);
      }
      return acc;
    }, []);
  }
);

// Optimized selectors that reuse existing memoized selectors
export const selectAllLeaseIds = createSelector(
  [selectLeaseIds, selectConnectionLeaseIds],
  (ownLeaseIds, connectionLeaseIds) => {
    // Combine all unique lease IDs
    return Array.from(new Set<number>([...ownLeaseIds, ...connectionLeaseIds]));
  }
);

export const selectHasMultipleLeases = createSelector(
  [selectLeaseIds, selectConnectionLeaseIds],
  (ownLeaseIds, connectionLeaseIds) => {
    return ownLeaseIds.length + connectionLeaseIds.length > 1;
  }
);

export const selectHasEmptyState = createSelector(
  [selectLeaseIds, selectConnectionLeaseIds],
  (ownLeaseIds, connectionLeaseIds) => {
    return ownLeaseIds.length + connectionLeaseIds.length === 0;
  }
);
